angular.module('pe4h').run(['$templateCache', function($templateCache) {
  $templateCache.put('components/root/alert-error.html',
    '<div class="modal-header">\n' +
    '    <a class="close" ng-click="$close();">\n' +
    '        <i class="fa fa-times"></i>\n' +
    '    </a>\n' +
    '    <h4 class="modal-title">{{header || \'error\'}}</h4>\n' +
    '</div>\n' +
    '<div class="modal-body">\n' +
    '    <p ng-if="!isList">{{msg}}</p>\n' +
    '    <ul ng-if="isList">\n' +
    '        <li ng-repeat="m in msg">{{m}}</li>\n' +
    '    </ul>\n' +
    '    <div ng-if="recoverPassword">\n' +
    '        <p>Click\n' +
    '            <a href="" ui-sref="forgotPassword" ng-click="$close();">here</a> to send a new link and reset your password</p>\n' +
    '    </div>\n' +
    '</div>\n' +
    '<div class="modal-footer">\n' +
    '    <a class="btn btn-primary" href="" ng-click="$close();" aria-label="Close">Close</a>\n' +
    '</div>');
}]);
